var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 679,
    viewBox: "0 0 618 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.067 455.894C201.251 457.25 160.033 463.089 123.317 493.452C111.844 502.942 103.063 512.948 96.4045 522.068C109.034 546.639 106.109 568.133 97.2101 572.772C89.812 576.623 76.3142 569.871 64.9521 557.984C38.141 560.332 16.2159 554.242 10.5216 541.054C8.81896 537.097 4.7709 523.695 34.5494 490.796C58.074 464.813 107.922 420.882 211.208 387.744",
    fill: "#CCE5FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.067 455.894C201.251 457.25 160.033 463.089 123.317 493.452C111.844 502.942 103.063 512.948 96.4045 522.068C109.034 546.639 106.109 568.133 97.2101 572.772C89.812 576.623 76.3142 569.871 64.9521 557.984C38.141 560.332 16.2159 554.242 10.5216 541.054C8.81896 537.097 4.7709 523.695 34.5494 490.796C58.074 464.813 107.922 420.882 211.208 387.744",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4252 539.78C35.5639 555.514 29.0826 573.588 32.5396 582.753C34.0995 586.884 37.6619 589.137 41.1689 589.208C50.3793 589.408 62.8131 574.63 70.1945 551.585",
    fill: "#CCE5FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4252 539.78C35.5639 555.514 29.0826 573.588 32.5396 582.753C34.0995 586.884 37.6619 589.137 41.1689 589.208C50.3793 589.408 62.8131 574.63 70.1945 551.585",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.827 528.163C29.726 530.459 27.4321 533.284 25.2129 536.671C22.2889 541.162 20.287 545.411 18.8946 548.956",
    fill: "#CCE5FD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.827 528.163C29.726 530.459 27.4321 533.284 25.2129 536.671C22.2889 541.162 20.287 545.411 18.8946 548.956",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M425.854 534.503C448.766 538.904 470.907 523.898 475.307 500.986C479.708 478.075 464.702 455.934 441.79 451.533C418.878 447.133 396.738 462.139 392.337 485.05C387.937 507.962 402.943 530.103 425.854 534.503Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297.27 273.132C304.996 275.455 312.726 277.761 320.452 280.084C329.138 255.282 394.043 74.161 468.728 71.686C473.189 71.5394 480.475 71.4065 487.136 75.9512C529.276 104.732 463.614 263.671 448.114 300.207C476.434 392.297 451.667 482.783 392.427 521.663C343.837 553.54 283.054 543.471 269.313 541.215C260.986 539.834 195.071 528.178 160.946 485.978C64.5161 366.687 261.676 52.1309 347.532 47.1497C352.312 46.8638 365.316 46.1144 372.131 54.1363C386.277 70.8087 360.2 109.418 334.423 168.023C323.506 192.852 309.554 228.262 297.291 273.118L297.27 273.132Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M372.624 256.331C382.105 234.035 393.872 209.625 408.524 183.963C424.334 156.261 440.642 132.139 456.115 111.506",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M220.83 214.593C233.055 193.682 247.803 170.939 265.562 147.333C284.741 121.847 303.958 99.9622 321.907 81.4459",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M133.96 365.975C127.807 398.01 148.789 428.968 180.824 435.121C212.86 441.274 243.817 420.292 249.97 388.257L251.984 377.771C258.137 345.736 237.155 314.778 205.12 308.625C173.084 302.472 142.127 323.454 135.974 355.489L133.96 365.975Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.925 405.54C174.354 408.311 189.243 393.937 193.181 373.436C197.118 352.934 188.613 334.067 174.184 331.296C159.755 328.524 144.866 342.898 140.929 363.4C136.991 383.902 145.496 402.768 159.925 405.54Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.592 418.396L162.27 387.138L195.274 399.278L166.592 418.396Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.212 344.493C141.754 338.761 148.975 324.624 164.877 315.82C185.127 304.605 213.347 305.373 232.953 322.584C257.024 343.716 252.315 375.739 251.983 377.755C214.398 366.669 176.796 355.579 139.212 344.493Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.871 383.466C226.719 415.501 247.7 446.459 279.736 452.612C311.771 458.765 342.729 437.783 348.882 405.747L350.896 395.262C357.049 363.226 336.067 332.269 304.031 326.116C271.996 319.963 241.038 340.945 234.885 372.98L232.871 383.466Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M258.838 423.022C273.267 425.793 288.156 411.42 292.094 390.918C296.031 370.416 287.527 351.549 273.098 348.778C258.668 346.007 243.779 360.38 239.842 380.882C235.904 401.384 244.409 420.251 258.838 423.022Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.513 435.925L261.195 404.649L294.199 416.789L265.513 435.925Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.12 362.001C240.662 356.268 247.884 342.131 263.785 333.328C284.036 322.112 312.255 322.88 331.862 340.091C355.933 361.223 351.223 393.246 350.891 395.262C313.306 384.176 275.705 373.087 238.12 362.001Z",
    fill: "#CCE5FD",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M355.731 284.298L306.709 265.938C298.24 262.767 288.804 267.061 285.632 275.529L283.351 281.619C280.179 290.088 284.473 299.525 292.942 302.696L341.964 321.056C350.433 324.228 359.869 319.934 363.041 311.465L365.322 305.375C368.494 296.906 364.199 287.47 355.731 284.298Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.741 280.298L216.076 281.406C225.117 281.597 232.602 274.423 232.793 265.381L232.931 258.88C233.122 249.839 225.948 242.354 216.906 242.163L164.571 241.056C155.53 240.864 148.045 248.038 147.854 257.08L147.716 263.581C147.525 272.623 154.699 280.107 163.741 280.298Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.424 453.578C206.148 468.546 215.248 481.859 225.713 483.978C237.231 486.318 252.287 475.455 252.781 458.257C238.325 456.684 223.883 455.133 209.427 453.56L209.424 453.578Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M355.235 436.212C375.051 434.855 416.269 429.017 452.985 398.654C464.458 389.164 473.239 379.157 479.898 370.038C467.269 345.466 470.193 323.973 479.092 319.334C486.49 315.483 499.988 322.234 511.35 334.122C538.161 331.773 560.086 337.863 565.781 351.052C567.483 355.009 571.531 368.41 541.753 401.31C518.228 427.293 468.381 471.223 365.095 504.361",
    fill: "#CCE5FD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M355.235 436.212C375.051 434.855 416.269 429.017 452.985 398.654C464.458 389.164 473.239 379.157 479.898 370.038C467.269 345.466 470.193 323.973 479.092 319.334C486.49 315.483 499.988 322.234 511.35 334.122C538.161 331.773 560.086 337.863 565.781 351.052C567.483 355.009 571.531 368.41 541.753 401.31C518.228 427.293 468.381 471.223 365.095 504.361",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M525.899 352.33C540.76 336.595 547.241 318.522 543.784 309.357C542.224 305.226 538.662 302.973 535.155 302.902C525.945 302.702 513.511 317.479 506.129 340.525",
    fill: "#CCE5FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M525.899 352.33C540.76 336.595 547.241 318.522 543.784 309.357C542.224 305.226 538.662 302.973 535.155 302.902C525.945 302.702 513.511 317.479 506.129 340.525",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M544.48 363.914C546.581 361.618 548.875 358.793 551.094 355.407C554.018 350.915 556.02 346.666 557.412 343.121",
    fill: "#CCE5FD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M544.48 363.914C546.581 361.618 548.875 358.793 551.094 355.407C554.018 350.915 556.02 346.666 557.412 343.121",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImg);
export default __webpack_public_path__ + "static/media/footerImg.215a15e4489003b75478e05c2f71874c.svg";
export { ForwardRef as ReactComponent };